module.exports = __webpack_public_path__ + "static/media/Icons-20x20-Arrow_up_Light Blue.1bc5b9cb.svg";